import api from '../api'
import { compareIds } from '../common/utils'

const initialState = {
  isLoading: false,
  list: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case api.getUsers.request:
      return {
        ...state,
        isLoading: true,
      }
    case api.getUsers.success:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
      }
    case api.getUsers.failure:
      return {
        ...state,
        isLoading: false,
      }
    case api.addUser.success:
      return {
        ...state,
        list: [...state.list, action.payload],
      }
    case api.deleteUser.success:
      return {
        ...state,
        list: state.list.filter(item => !compareIds(item.userId, action.route)),
      }
    case api.updateUser.success:
      return {
        ...state,
        list: state.list.map(item => {
          if (compareIds(item.userId, action.route)) {
            return action.payload
          }
          return item
        }),
      }
    default:
      return state
  }
}
